import { StyleSheet } from "../../core";
const gridTableStyles = StyleSheet.create({
  screenLayout: {
    backgroundColor: "#fff",
    marginTop: 0,
    marginRight: 16,
    marginBottom: 16,
    marginLeft: 16,
    padding: 16,
    paddingTop: 0,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#e2e2e2",
    width: "100%",
    height: '100%',
    borderRadius: 5,
    screen: ({ width }) => {
      if (width <= 991)
        return {
          marginTop: 0,
          marginRight: 0,
          marginLeft: 0,
          marginBottom: 70,
          borderColor: "#fff",
        };
    },
  },
  cellStyle: {
    justifyContent: "center",
    minHeight: 24,
    padding: 4,
    paddingLeft: 10,
    paddingRight: 10,
  },
  cellText: {
    color: "#182832",
    fontSize: 11,
    wordBreak: 'break-word',
  },
  headerTitleTextStyle: {
    fontSize: 14,
  },
  btnHeight: {
    maxHeight: 20,
    zIndex: 2
  },
  zIndex2: {
    zIndex: 2
  },
  statusCircle: {
    borderWidth: 5,
    borderStyle: "solid",
    borderRadius: 15,
    maxWidth: 5,
    maxHeight: 5,
    marginRight: 7,
  },
  statusWrapperStyle: {
    maxHeight: 26,
    minHeight: 30,
  },

});

export { gridTableStyles };